import type { FC } from "react";
import { useBoolean } from "usehooks-ts";

import {
  INSTRUCTOR_FORUM_USER_GUIDE_URL,
  RELEASE_NOTES_URL,
  STUDENT_FORUM_USER_GUIDE_URL,
} from "../../utils/urls";

import { BugReportModal } from "components/header/BugReportModal";
import { useIntercomWithDefaults } from "components/intercom/use-intercom-with-defaults";
import { t } from "i18n/i18n";
import { Menu, MenuDivider, MenuItem } from "mds/components/Menu";
import { Tooltip } from "mds/components/Tooltip";
import { SquareIconButton } from "mds/components/buttons/SquareIconButton";
import { CircleQuestionIcon } from "mds/icons";
import { useCapabilities } from "store/capability-hooks";
import { isIntercomEnabled } from "utils/waffle-flags";

export const HelpCenterMenu: FC = () => {
  const { showIntercom } = useIntercomWithDefaults();
  const { canAuthorSection } = useCapabilities();
  const {
    value: bugReportModalIsShown,
    setTrue: showBugReportModal,
    setFalse: hideBugReportModal,
  } = useBoolean(false);

  const handleContactSupport = () => {
    if (!isIntercomEnabled()) return;

    showIntercom();
  };

  const MenuButton = (
    <div>
      <Tooltip content={t("help_center.title")}>
        <SquareIconButton aria-label={t("help_center.title")} kind="secondary" size="s">
          <CircleQuestionIcon />
        </SquareIconButton>
      </Tooltip>
    </div>
  );

  return (
    <>
      <Menu menuButton={MenuButton}>
        {isIntercomEnabled() && (
          <>
            <MenuItem
              eventName="Help Center - Contact support"
              title={t("help_center.contact_support")}
              onClick={handleContactSupport}
            >
              {t("help_center.contact_support")}
            </MenuItem>
            <MenuDivider />
          </>
        )}
        <MenuItem
          eventName="Help Center - User guide"
          title={t("help_center.forum_user_guide")}
          onClick={() =>
            window.open(
              canAuthorSection ? INSTRUCTOR_FORUM_USER_GUIDE_URL : STUDENT_FORUM_USER_GUIDE_URL,
              "_blank",
              "noopener",
            )
          }
        >
          {t("help_center.forum_user_guide")}
        </MenuItem>
        <MenuItem
          eventName="Help Center - Release notes"
          title={t("help_center.release_notes")}
          onClick={() => window.open(RELEASE_NOTES_URL, "_blank", "noopener")}
        >
          {t("help_center.release_notes")}
        </MenuItem>
        <MenuDivider />
        <MenuItem
          eventName="Help Center - Report a problem"
          title={t("help_center.report_problem")}
          onClick={showBugReportModal}
        >
          {t("help_center.report_problem")}
        </MenuItem>
      </Menu>

      <BugReportModal open={bugReportModalIsShown} onClose={hideBugReportModal} />
    </>
  );
};
